import axios from 'axios';
import BaseAPI from './base/base-api';

class SubscriberAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'subscribers';

}

export default new SubscriberAPI();